import React from "react";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { useParams } from "react-router";
import { InviteRouteParams } from "../models";
import { useGetInvitationValidationQuery } from "../queries";
import { useVisualProvider } from "../../../components/layout/useVisualProvider";

const InviteHeading: React.FC = (): React.ReactElement => {
  const { tInvite } = useCustomTranslation();
  const { companyName } = useVisualProvider();

  const params = useParams<InviteRouteParams>();

  const invitationValidationQuery = useGetInvitationValidationQuery(
    params.invitationGuid,
  );

  const customerName = invitationValidationQuery.data?.customerName;

  return (
    <div>
      <h1>{tInvite("title", { companyName })}</h1>
      <p className="font-bold">
        {tInvite("invited_user", { invitedUser: customerName })}
      </p>
    </div>
  );
};

export default InviteHeading;
